<section class="px-16 py-12.5 lg:w-126.5 bg-white rounded-lg text-center">
  <h2 class="text-[28px] font-bold mb-4">Update Court File Number</h2>

  <form [formGroup]="form">
    <div class="mb-6">
      <app-dashboard-alert
        type="warning"
        [message]="`Editing the auto-generated number. Original: ${currentFileNumber}`" />
    </div>
    <app-ccs-input label="Court File Number" formControlName="fileNumber" />
    <p class="text-neutral-600 text-left text-xs">Manual entry mode.</p>

    <div class="mt-10">
      <div class="flex justify-end gap-11">
        <ui-button mat-dialog-close class="w-full" [outline]="true"
          >Cancel</ui-button
        >
        <ui-button
          [mat-dialog-close]="form.controls.fileNumber.value"
          [disabled]="form.invalid || form.pristine"
          type="submit"
          class="w-full"
          >Confirm</ui-button
        >
      </div>
    </div>
  </form>
</section>
